import request from "@/utils/request";
/**
 * 获取到ip地址相关的信息
 */
 export function getIpInfo() {
    return request({
        url: 'https://api.myip.la/cn?json',
        method: 'get',
    })
  }